module.exports = __webpack_public_path__ + "img/stock3.d79a0b61.png";